"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
const components_1 = require("./InputElement/components");
function Label(_a) {
    var { inputKind, optional, hideOptionalLabel } = _a, props = __rest(_a, ["inputKind", "optional", "hideOptionalLabel"]);
    const { t } = (0, app_1.useTranslation)();
    const labelStyle = (0, react_1.useMemo)(() => (0, app_1.css) `
      ${(theme) => theme.inputs.label}
      ${(theme) => { var _a; return (_a = theme.inputs[inputKind]) === null || _a === void 0 ? void 0 : _a.label; }}
    `, [inputKind]);
    const child = (0, react_1.useMemo)(() => typeof props.children === 'string' && !hideOptionalLabel
        ? `${optional ? '' : '*'}${props.children}${optional ? ` (${t('label.optional')})` : ''}`
        : props.children, [hideOptionalLabel, optional, props.children, t]);
    return ((0, jsx_runtime_1.jsx)(components_1.StyledLabel, Object.assign({}, props, { css: labelStyle }, { children: child })));
}
exports.Label = Label;
